import {
  arrayOf, bool, extend, number, params, shape, string
} from '@thd-nucleus/data-sources';

const openCloseShape = shape({
  open: string(),
  close: string()
});

const storeHoursShape = shape({
  monday: openCloseShape,
  tuesday: openCloseShape,
  wednesday: openCloseShape,
  thursday: openCloseShape,
  friday: openCloseShape,
  saturday: openCloseShape,
  sunday: openCloseShape
});

const store = {
  storeSearch: params({ storeSearchInput: string().isRequired(), pagesize: string() }).shape({
    stores: arrayOf(shape({
      address: shape({
        street: string(),
        city: string(),
        country: string(),
        state: string(),
        postalCode: string()
      }),
      coordinates: {
        lat: number(),
        lng: number()
      },
      flags: {
        bopisFlag: bool(),
        bodfsFlag: bool(),
        curbsidePickupFlag: bool()
      },
      distance: string(),
      name: string(),
      phone: string(),
      proDeskPhone: string(),
      storeServicesPhone: string(),
      toolRentalPhone: string(),
      services: shape({
        hdMoving: bool(),
        loadNGo: bool(),
        propane: bool(),
        toolRental: bool(),
        penske: bool(),
        keyCutting: bool(),
        wiFi: bool(),
        applianceShowroom: bool(),
        expandedFlooringShowroom: bool(),
        largeEquipment: bool(),
        kitchenShowroom: bool()
      }),
      storeDetailsPageLink: string(),
      storeId: string(),
      storeHours: storeHoursShape,
      proDeskHours: storeHoursShape,
      toolRentalHours: storeHoursShape,
      curbsidePickupHours: storeHoursShape,
      storeType: string(),
      storeTimeZone: string()
    }))
  })
};

export const storeDataModel = extend(store);
